export const iconFontAwesomeShoppingCameraRetro = (
	<i className="fa-solid fa-camera-retro"></i>
);
